/**
 * Хранение токена админки в sessionStorage.
 */

import { DEV_TOKEN_KEY } from "../config/dev";

export function getDevToken() {
    try {
        return sessionStorage.getItem(DEV_TOKEN_KEY) || "";
    } catch (error) {
        console.error("Ошибка чтения токена админки:", error);
        return "";
    }
}

export function setDevToken(token) {
    try {
        sessionStorage.setItem(DEV_TOKEN_KEY, token);
    } catch (error) {
        console.error("Ошибка записи токена админки:", error);
    }
}

export function clearDevToken() {
    try {
        sessionStorage.removeItem(DEV_TOKEN_KEY);
    } catch (error) {
        console.error("Ошибка очистки токена админки:", error);
    }
}

// utils/devAuth.js
